module.exports = __webpack_public_path__ + "assets/6258992108a8d05f924b0063c54a5628.mp3";